import { COMMON } from "root/libs/constants/src";

/*  New structure of the Offers Array to align towards MultiBU with all Offers
    we will return a new array looking like this:
        [method: "WALK", offers: [a, b, c, d]][method: "CLICK", offers: [e, f, g]] [method: "CALL", offers: [h, i]]
    this array will then be consumed inside the WCCOfferCardWrapper where we will connect the header towards the offers inside the associated payment method.
    */
export const sortMultiBUOffersByPurchaseMethod = (offers) => {
  // TODO: get the highlighted method from the country settings
  const highlightedMethod = "CLICK";
  const returnOffersArrayByMethod = [
    { method: "WALK", offers: [], isHighlighted: false },
    { method: "CLICK", offers: [], isHighlighted: true },
    { method: "CALL", offers: [], isHighlighted: false },
    { method: "TARGET_SERVICE", offers: [], isHighlighted: false },
  ].map((obj) => {
    if (obj.method === highlightedMethod) {
      return { ...obj, isHighlighted: true };
    }
    return obj;
  });

  offers.forEach((offer) => {
    if (
      offer.key === COMMON.TARGET_SERVICE_CARD_KEY ||
      offer.key === COMMON.DOMESTIC_TRANSPORT_SOLUTION_CARD_KEY
    ) {
      returnOffersArrayByMethod
        .find((obj) => obj.method === "TARGET_SERVICE")
        .offers.push(offer);
    } else {
      returnOffersArrayByMethod
        .find((obj) => obj.method === offer.purchaseMethod)
        .offers.push(offer);
    }
  });
  returnOffersArrayByMethod.flat();

  return returnOffersArrayByMethod;
};
